"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GlobalCtx_1 = __importDefault(require("./GlobalCtx"));
const index_1 = require("./index");
class AudioSource {
    constructor(buffer) {
        this.buffer = buffer;
        this.gain = GlobalCtx_1.default.ctx.createGain();
        this.gain.connect(GlobalCtx_1.default.destination);
    }
    get destination() {
        return this.gain;
    }
    get volume() {
        return Math.sqrt(this.gain.gain.value);
    }
    set volume(v) {
        this.gain.gain.value = v * v;
    }
    get duration() {
        if (this.buffer) {
            return this.buffer.duration;
        }
        return 0;
    }
    createInstance() {
        return new index_1.AudioInstance(this);
    }
    static from(getsource) {
        return new Promise((res, rej) => {
            function load(data) {
                if (data instanceof Blob) {
                    const reader = new FileReader();
                    reader.onabort = rej;
                    reader.onerror = rej;
                    reader.onload = e => (reader.result instanceof ArrayBuffer ? load(reader.result) : rej(e));
                    reader.readAsArrayBuffer(data);
                }
                else {
                    GlobalCtx_1.default.ctx.decodeAudioData(data, buffer => res(new AudioSource(buffer)), rej);
                }
            }
            const src = getsource instanceof Function ? getsource() : getsource;
            if (typeof src === "string") {
                fetch(src)
                    .then(x => x.arrayBuffer())
                    .then(load)
                    .catch(rej);
            }
            else if (src instanceof Promise) {
                src.then(load).catch(rej);
            }
            else {
                load(src);
            }
        });
    }
}
exports.default = AudioSource;
//# sourceMappingURL=AudioSource.js.map